import React from 'react';

const LoadingSpinner = ({ message, step = 1 }) => {
  // Get step-specific messages
  const getStepMessage = () => {
    if (message) return message; // Use custom message if provided
    
    switch (step) {
      case 1:
        return (
          <>
            <strong>The admissions committee is evaluating your demographics and academic foundation.</strong>
            <br /><br />
            Please have your work experience/resume ready for the next step, where the committee will comprehensively assess your professional background alongside your academic credentials.
          </>
        );
      case 2:
        return (
          <>
            <strong>The admissions committee is evaluating your work experience and professional background.</strong>
            <br /><br />
            Please prepare your essays for the next step, where the committee will conduct a final comprehensive evaluation of your complete application.
          </>
        );
      case 3:
        return (
          <>
            <strong>The admissions committee is conducting their final comprehensive evaluation.</strong>
            <br /><br />
            They are reviewing your complete application including demographics, academics, work experience, and essays to make their final admission decision.
          </>
        );
      default:
        return "Processing your evaluation...";
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md mx-4 text-center">
        <div className="spinner w-12 h-12 mx-auto mb-4"></div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Please wait</h3>
        <div className="text-gray-600 text-sm leading-relaxed">
          {getStepMessage()}
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner; 